export default __webpack_public_path__ + "static/media/logoai.fdda1f1c.png";